import React, {useEffect, useState, useRef, useContext} from 'react';
import LineClampText from './LineClampText';
import {ContentContainer} from '../Landing/styles';
import PageTitle from '../components/PageTitle';
import {ELanguage, Slider, Utils} from '@microfrontends/react-components';
import {ArticleGridItem, ArticleListItem, GridLayout} from './styles';
import ActionButton from '../components/ActionButton';
import AppContext from '../../../context/AppContext';
import {EDevice} from '../../../containers/MainLayout';
import {CalendarIcon} from '../assets/icons';
function stripHtmlTags(html)
	{
		return html.replace(/<[^>]*>/g, '');
	}

class Article {
	id!: number
	content!: string
	title!: string
	cover_picture!: string
	cover_picture_full!: string
	publishedDate!: string
	description!: string
	hrDetailSlug!: string
	tags!: {id: number, hr_tag_id: number, name: string}[]
	url!: string
	
	constructor(props, pageUrl = '', utm = '')
		{
			Object.assign(this, props)
			this.title = stripHtmlTags(props.title)
			this.description = stripHtmlTags(props.short_description)
			this.tags = props.tags || []
			this.url = pageUrl + this.hrDetailSlug + (utm.startsWith('?') ? utm : '?' + utm)
			this.publishedDate = new Date(props.published_date.split(' ')[0]).toLocaleDateString('vi-VN', {year: 'numeric', month: '2-digit', day: '2-digit'})
			this.cover_picture_full = this.cover_picture.replace(/-\d{3}x\d{3}/gi, '')
		}
		
		get concatTag() {
		return this.tags.map(({name}) => name).join(', ')
		}
}

type TEmagazineProps = {
	apiUrl?: string
	viewAllUrl?: string
	vnwUrl?: string
	tagIds: number[],
	language: ELanguage,
	limit?: number,
	utm?: string,
	layout?: 'grid' | 'list'
	title: string,
	isBot?: boolean
	id: string
	
}

const ListArticles = ({articles, isBot}: {articles: Article[], isBot?: boolean}) => {
	const { breakpoint } = useContext(AppContext)
	return <div>
		
		<Slider
			id={`hr-insider-list-article`}
			slides={{ spaceBetween: 32, elementPerView: [EDevice.DESKTOP, EDevice.LAPTOP].includes(breakpoint as any) ? 4 : (EDevice.TABLET === breakpoint ? 2 : 1) }}
			pagination={{ maxShow: 6, type: 'default' }}
			loadingEnable={false}
			loadingHeight={445}
			container={{ style: { width: '100%' } }}
			isRobot={isBot}
		>
			{articles.map(article => <ArticleListItem href={article.url} target="_blank" className='swiper-slide' key={article.id}>
				<img className="cover" src={article.cover_picture}/>
				<div className="title">
					<LineClampText content={article.title} lines="2"/>
				</div>
				<div className="description">
					<LineClampText content={article.description} lines="3"/>
				</div>
				<div className="article-tag">
					{article.concatTag}
				</div>
			</ArticleListItem>)}
		</Slider>
	</div>
}

const GridArticles = ({articles}: {articles: Article[]}) => <GridLayout>
	{
		articles.map((article, index) => <ArticleGridItem key={article.id}>
			<picture>
				<img src={index ? article.cover_picture : article.cover_picture_full}/>
			</picture>
			<a href={article.url} target="_blank" className="article-link">
				<LineClampText content={article.title} lines="3"/>
			</a>
			
			<p>
				<LineClampText content={article.description} lines="4"/>
			</p>
			<div className="publish-date">
				<i>
					<CalendarIcon/>
				</i>
				{article.publishedDate}
			</div>
		</ArticleGridItem>)
	}
</GridLayout>

const HRInsiderBlogPosts: (props: TEmagazineProps) => JSX.Element = (props) =>
	{
		const {
			apiUrl = 'https://ms.vietnamworks.com',
			viewAllUrl = 'https://www.vietnamworks.com/hrinsider',
			vnwUrl = 'https://www.vietnamworks.com',
			tagIds,
			language = 'vi',
			limit = 5,
			utm = '',
			layout = 'grid',
			title,
			isBot,
			id
		} = props
		const [articles, setArticles] = useState<Article[]>([]);
		const prevTagIdsWatch = useRef(tagIds);
		
		useEffect(() =>
		{
			// Fetch articles from the API
			const url = tagIds && tagIds.length > 0 ?
				`${apiUrl}/navi-api/api/blogs-by-hr-tag?tag_ids=${tagIds.join(',')}&limit=${limit}`
				: `${apiUrl}/navi-api/api/blogs?limit=${limit}`;
			prevTagIdsWatch.current = tagIds;
			fetch(url)
				.then(response => response.json())
				.then(data =>
				{
					if (Array.isArray(data) && data.length > limit) {
						data = data.slice(0, limit)
					}
					const articles = data.map((rawData: any) => new Article(rawData, vnwUrl, utm));
					setArticles(articles);
				})
				.catch(error =>
				{
					setArticles([]);
				});
		}, []);
		
		return (
			<ContentContainer narrowedWidth>
				<PageTitle id={id}>
					{title}
				</PageTitle>
				
				{
					(layout === 'grid')
						? <GridArticles articles={articles}/>
						: <ListArticles articles={articles} isBot={isBot}/>
				}
				<div style={{display: 'flex', justifyContent: 'center', margin: '25px 0'}}>
					<ActionButton variant='orange' href="https://www.vietnamworks.com/hrinsider/hanh-trang-fresher/e-magazine-fresher" target="_blank">
						Tìm hiểu thêm
					</ActionButton>
				</div>
			</ContentContainer>
		
		);
	};

export default React.memo(HRInsiderBlogPosts, (prevProps, nextProps) => Utils.isDifferentArrayData(prevProps.tagIds, nextProps.tagIds));
